//Modulos
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

//Componentes
import { ModalCargandoComponent } from './componentes/modal-cargando/modal-cargando.component';
import { ModalErrorComponent } from './componentes/modal-error/modal-error.component';
import { ModalExitoComponent } from './componentes/modal-exito/modal-exito.component';
import { GroupByPipe } from './pipes/group-by.pipe';
import { ModalConfirmacionComponent } from './componentes/modal-confirmacion/modal-confirmacion.component';

@NgModule({
  declarations: [
    // Componentes
    ModalCargandoComponent,
    ModalErrorComponent,
    ModalExitoComponent,
    ModalConfirmacionComponent,
    // Pipes
    GroupByPipe,
  ],
  imports: [
    ReactiveFormsModule,
    NgbModule,
    CommonModule,
    RouterModule
  ],
  exports: [
    ReactiveFormsModule,
    NgbModule,
    CommonModule,
    ModalCargandoComponent,
    ModalErrorComponent,
    ModalExitoComponent,
    ModalConfirmacionComponent,
    GroupByPipe
  ]
})
export class SharedModule { }
